<template>  

  <nav class="navbar bg-orange">     

    <div>   
      <div class="d-flex align-items-center pointer" v-if="returnAction" v-on:click="emitReturn">
        <font-awesome-icon :icon="['fas', 'angle-left']" />
      </div>
      <div class="d-flex flex-row align-items-center"  v-else>
        <div class="d-flex justify-content-center align-items-center pointer rounded-circle bg-white" style="width: 2.5rem; height: 2.5rem;">
          <img class="logo" src="../../assets/images/logo-psicoapp-desenho.png" alt="" style="width:36px;height:36px">
        </div>
        <div class="px-1">
          <h5 class="p-0 m-0">PsicoApp</h5>
        </div>
      </div>
    </div>

    <div v-if="pageName">
      <h5 class="m-0 p-0">{{pageName}}</h5>
    </div>

    <div class="d-flex flex-row justify-content-center align-items-center">
      <nav-icon class="mx-1" :iconName="'plus'" v-on:click="emitCreate" v-if="createAction" />      
      <nav-icon class="mx-1" :iconName="'search'" v-on:click="emitSearch" v-if="searchAction" />      
      <nav-icon class="mx-1" :iconName="'floppy-disk'" v-on:click="emitSave" v-if="saveAction" />
      <nav-icon class="mx-1" :iconName="'share-nodes'" v-on:click="emitShare" v-if="shareAction" />
      <nav-icon class="mx-1" :iconName="'sync'" v-on:click="emitRefresh" v-if="refreshAction" />
      <nav-icon class="mx-1" :iconName="'check'" v-on:click="emitCheck" v-if="checkAction" />
      <span
        v-if="pageName && !createAction && !searchAction && !saveAction && !refreshAction && !checkAction && !shareAction"
      ></span>
    </div>
                
  </nav>
   
</template>

<script>
import { useUserStore } from '@/store/user';

export default {
  name: 'NavBar',
  emits:["create", "save", "search", "refresh", "check", "return"],
  setup() {
    const userStore = useUserStore();

    return { userStore }
  },
  mounted() {
    let user = this.userStore.getUser;
    let userType = user.type;
    this.userName = user.name;
    this.clinicName = user.clinicName;
    this.clinicCodeName = user.clinicCodeName;    

    if (userType == 'Professional') { this.professional = true; }
    else if (userType == 'Patient') { this.patient = true; }
    else if (userType == 'Administrator') { this.administrator = true; }
  },
  props: {
    returnAction: {
      type:Boolean,
      default: false
    },
    createAction: {
      type:Boolean,
      default:false
    },
    saveAction: {
      type:Boolean,
      default: false
    },
    searchAction: {
      type: Boolean,
      default: false
    },
    refreshAction: {
      type: Boolean,
      default: false
    },
    checkAction: {
      type: Boolean,
      default: false
    },
    shareAction: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String
    }
  },  
  data() {
    return {            
      professional:false,
      patient:false,
      administrator:false,
      userName:"",
      clinicName:"",
      clinicCodeName:"",      
    }
  },
  methods: {
    
    // openFourLionsPage() {
    //   window.open("https://fourlions.com.br/", '_blank').focus();
    // },
    // openSideBar() {
    //   let sideBar = document.getElementById("side-bar");

    //   sideBar.classList.add("nav-open");
    // },
    // closeSideBar() {
    //   let sideBar = document.getElementById("side-bar");

    //   sideBar.classList.remove("nav-open");
    // },
    emitCreate() {
      this.$emit("create");
    },
    emitSave() {
      this.$emit("save");
    },
    emitSearch() {
      this.$emit("search");
    },
    emitRefresh() {
      this.$emit("refresh");
    },
    emitCheck() {
      this.$emit("check")
    },
    emitShare() {
      this.$emit("share")
    },
    emitReturn() {
      this.$emit("return");
    }
  },  
    
}
</script>

<style lang="css" scoped>
@import "../../assets/css/_colors";
.pointer {
  cursor: pointer;
}

.navbar {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding-left: 1rem;
  padding-right: 1rem;
  min-height: 54px;
  height: 54px;
  max-height: 54px;
  color: white;    
  position: sticky;
  top: 0;
  z-index: 3;
  overflow:visible;
  padding-top: 0;
  padding-bottom: 0;
}

.nav-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
}

.nav-button {
    min-width: 30px;
    min-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    border-radius: 50%;
    transition: transform 300ms, background-color 300ms;
    animation: pulse 500ms;
    background-color: #7DA8FF;
}

.nav-button:hover {
    transform: scale(1.05);
    background-color: #4a86ff;
}

.nav-button:active {
    transform: scale(0.95);
    animation: none;
}

@keyframes pulse {
    from {
        box-shadow: #69bcff 0 0 0;
    }
    to {
        box-shadow: #69fff380 0 0 22px;
    }
}

.logo {
    max-width: 35px;
    max-height: 31px;
}

.logo-4lions {
    max-width: 200px;
    max-height: 130px;
}


.nav-main {    
    color: white;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5001;
    height: 100vh;
    width: 250px;
    background: #FBB77F;
    transform: translateX(-250px);
    transition: 0.3s;
}

.nav-open .nav-main {
    transform: translateX(0);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column; 
}

.nav-header {
    display: flex;
    justify-content: center;
    align-items: center;
}

.nav-body {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
}

.nav-link {
    display: flex;
    align-items: center;
    font-size: 1rem;    
    color: azure;
    font-weight: bold;    
    text-decoration: none;
    padding: 12px 15px;
    background: transform 0.2s;
    border: 1px solid rgba(0,0,0,0.17);
    border-radius: 2px;
}

.nav-link > span {
    margin-left: 5px;    
}

.nav-link-active {
    color: #7DA8FF;
    background: rgba(59, 57, 57, 0.664);
}

.nav-link-active,
.nav-link:hover {
    background: rgba(59, 57, 57, 0.664);
}

.nav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);    
    z-index: 5000;
    visibility: hidden;
    opacity: 0;    
    transition: 0.6s;
}

.nav-open .nav-overlay {
    visibility: visible;
    opacity: 1;
}     
</style>
